import { render, staticRenderFns } from "./TheAsideBar.vue?vue&type=template&id=ae7f4648&scoped=true&"
import script from "./TheAsideBar.vue?vue&type=script&lang=js&"
export * from "./TheAsideBar.vue?vue&type=script&lang=js&"
import style0 from "./TheAsideBar.vue?vue&type=style&index=0&id=ae7f4648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7f4648",
  null
  
)

export default component.exports